var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showA2HS
    ? _c(
        "div",
        [
          _vm.modalVisible
            ? _c(
                "base-dialog",
                {
                  attrs: {
                    okFn: _vm.addToHomeScreen,
                    cancelFn: _vm.saveNotAddingToHomeScreen,
                    okBtnText: _vm.$t("a2hs.modal-install-btn")
                  },
                  model: {
                    value: _vm.modalVisible,
                    callback: function($$v) {
                      _vm.modalVisible = $$v
                    },
                    expression: "modalVisible"
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-4 d-flex" }, [
                      _c("img", {
                        staticClass: "img-fluid m-auto",
                        attrs: { src: _vm.getAppIcon, alt: "App icon" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("a2hs.modal-message", {
                              platform: _vm.getPlatformName
                            })
                          )
                        )
                      ])
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.deferredPrompt || _vm.deviceIsAllowedIOS
            ? _c(
                "div",
                {
                  staticClass: "install-app-block",
                  class: {
                    animate: _vm.animateActive,
                    shadow: _vm.shadow,
                    white: _vm.white
                  },
                  on: { click: _vm.addToHomeScreen }
                },
                [
                  _c("img", {
                    staticClass: "d-inline-block mr-2",
                    attrs: { src: _vm.getAppIcon }
                  }),
                  _vm._v(" "),
                  !_vm.small
                    ? _c("span", { staticClass: "d-inline-block" }, [
                        _vm._v(
                          _vm._s(_vm.$t("a2hs.modal-install-btn")) + " app"
                        )
                      ])
                    : _c("base-icon", {
                        staticClass: "d-inline-block ml-2",
                        attrs: {
                          blue: !_vm.white,
                          white: _vm.white,
                          src:
                            "/static-appopensalud/img/icons/install-browser.svg",
                          alt: "Instalar"
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.safariTooltipVisible
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: function() {
                        return (_vm.safariTooltipVisible = false)
                      },
                      expression: "() => safariTooltipVisible = false"
                    }
                  ],
                  staticClass: "safari-tooltip"
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("a2hs.safari-tooltip", {
                          shareIconImg: _vm.shareIconImg
                        })
                      )
                    }
                  })
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48d0a069", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d0a069","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/AddToHomeScreen.vue
// module id = 1655
// module chunks = 117